<div class="card rounded-12 mb-2 border border-cool-gray" [ngClass]="wrapperClass" *ngIf="loader">
    <ul class="list-group list-group-flush">
        <li class="list-group-item" *ngFor="let item of [1,2,3]">
            <div class="d-flex align-items-center">
                <div class="shimmer ">
                    <div class="rounded-8 placeholder shimmer" style="width: 40px; height: 40px;"></div>
                </div>
                <div class="ms-3 w-100">
                    <h6 class=" mb-1">
                        <span class="placeholder shimmer col-6"></span>
                    </h6>
                    <p class="mb-0">
                        <span class="placeholder shimmer col-4"></span>
                    </p>
                </div>
            </div>
        </li>
        <li class="list-group-item">
            <span class=" d-flex align-items-center">
                <span class="placeholder shimmer rounded-circle me-2" style="width: 20px; height: 20px;"></span>
                <span class="placeholder shimmer col-6"></span>
            </span>
        </li>
    </ul>
</div>

<div class="workspace-selector-card-wrapper position-relative" *ngIf="!loader">
    <div class="card rounded-12 mb-2 border border-cool-gray" [ngClass]="wrapperClass">
        <ul class="list-group list-group-flush">
            <li class="list-group-item"
                [ngClass]="{'active-work-space' : isShowEditIcon && item?.id === activeWorkspace?.id}"
                *ngFor="let item of items?.slice(0,3)" (click)="emitWorkSpaceEvent($event ,'select' ,item)">
                <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                        <img [src]="item.logo_url" *ngIf="item.logo_url" class="workspace-image rounded-8"
                            alt="default-logo">
                        <div class="image-wrapper rounded-8 d-flex justify-content-center align-items-center"
                            *ngIf="!item.logo_url">
                            <img [src]="defaultImage" alt="deafult-image" width="22">
                        </div>
                        <div class="ms-3">
                            <h6 class="fs-14 mb-0 text-secondary-grey">{{item.name}}</h6>
                            <div class="d-flex align-items-center">
                                @if(item.staff_members?.length){
                                <app-avatar-stack [avatarArray]="item.staff_members">
                                </app-avatar-stack>
                                }
                                @if(showMemberDetail()){
                                <small class="text-secondary-grey"
                                    [ngClass]="{'ms-2' : item.staff_members?.length}"><span>{{item.staff_members?.length}}</span>
                                    Member</small>
                                }
                            </div>
                        </div>
                    </div>
                    <div *ngIf="isShowEditIcon" (click)="editEvent($event , item.id)">
                        <img src="assets/icons/fa-edit.svg" alt="edit-icon" width="16">
                    </div>
                    @if(showRemoveLink()){
                        <div (click)="emitWorkSpaceEvent($event,'delete' , item)">
                            <span class="fs-10 "><a  class="text-brand-warning">Remove</a></span>
                        </div>
                        }
                </div>
            </li>
            @if(items?.length < 3){
            <li class="list-group-item "  (click)="emitWorkSpaceEvent($event ,'add')">
                <span><img [src]="addButtonIcon()" alt=""> <span class="text-secondary-grey fs-14 ms-2">
                       {{addButtonLabel()}} </span></span>
            </li>
        }
        </ul>
    </div>
    @if(workspaceLoader()){
        <div class="workspace-selector-overlay">
            <app-spinner [loader]="true" [wrapperClass]="'text-brand-purple'"></app-spinner>
        </div>
    }
</div>